// src/components/NavBar.jsx
import React, { useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

export default function NavBar() {
  const logo = `${process.env.PUBLIC_URL}/logo192.jpg`;
  const { pathname } = useLocation();

  const scrollTop = () => window.scrollTo(0, 0);

  // Fermer automatiquement le collapse à chaque changement de route
  useEffect(() => {
    const el = document.getElementById("navMain");
    if (!el) return;
    // Si Bootstrap bundle est chargé, on utilise son API
    const api = window.bootstrap
      ? new window.bootstrap.Collapse(el, { toggle: false })
      : null;
    if (api) api.hide();
    else el.classList.remove("show"); // fallback
  }, [pathname]);

  // Fermer immédiatement au clic (utile pour mobile)
  const closeCollapseNow = () => {
    const el = document.getElementById("navMain");
    if (!el) return;
    el.classList.remove("show");
  };

  return (
    <>
      {/* TOP BAR */}
      <div className="topbar">
        <div className="container d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center gap-3 topbar-contacts">
            <a className="topbar-link" href="tel:+22890119255">
              <i className="bi bi-telephone me-1" /> +228 90 11 92 55
            </a>
            <a className="topbar-link" href="mailto:contact@mameche.tg">
              <i className="bi bi-envelope me-1" /> contact@mameche.tg
            </a>
          </div>
          <Link
            to="/contact"
            className="btn btn-outline-light btn-sm rounded-pill px-3"
            onClick={() => { scrollTop(); closeCollapseNow(); }}
          >
            Devis
          </Link>
        </div>
      </div>

      {/* MAIN NAV */}
      <nav className="navbar navbar-expand-lg navbar-light bg-white border-bottom sticky-top mainnav">
        <div className="container">
          {/* Logo */}
          <Link
            className="navbar-brand d-flex align-items-center"
            to="/"
            onClick={() => { scrollTop(); closeCollapseNow(); }}
          >
            <img src={logo} alt="MAMECHE" className="brand-logo me-2" />
          </Link>

          {/* Burger */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navMain"
            aria-controls="navMain"
            aria-expanded="false"
            aria-label="Basculer la navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          {/* Menu */}
          <div id="navMain" className="collapse navbar-collapse">
            <ul className="navbar-nav mx-auto align-items-center">
              <li className="nav-item">
                <NavLink
                  end to="/"
                  className="nav-link"
                  onClick={() => { scrollTop(); closeCollapseNow(); }}
                >
                  Accueil
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/about"
                  className="nav-link"
                  onClick={() => { scrollTop(); closeCollapseNow(); }}
                >
                  À propos
                </NavLink>
              </li>

              <li className="nav-item">
                <NavLink
                  to="/service"
                  className="nav-link"
                  onClick={() => { scrollTop(); closeCollapseNow(); }}
                >
                  Service après-vente
                </NavLink>
              </li>

              {/* Dropdown Produits */}
              {/* ====== Desktop : vrai dropdown ====== */}
              <li className="nav-item dropdown d-none d-lg-block">
                <a
                  href="#"
                  id="navProducts"
                  className="nav-link dropdown-toggle nav-products-toggle"
                  role="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  onClick={(e) => e.preventDefault()}
                >
                  Nos produits
                </a>
                <ul className="dropdown-menu" aria-labelledby="navProducts">
                  <li><Link className="dropdown-item" to="/medical/products">Médical – Produits</Link></li>
                  <li><Link className="dropdown-item" to="/industrial/products">Industriel – Produits</Link></li>
                  <li><hr className="dropdown-divider" /></li>
                  <li><Link className="dropdown-item" to="/medical/works">Médical – Réalisations</Link></li>
                  <li><Link className="dropdown-item" to="/industrial/works">Industriel – Réalisations</Link></li>
                </ul>
              </li>

              {/* ====== Mobile : sous-menu en Collapse ====== */}
              <li className="nav-item d-lg-none">
                <button
                  className="nav-link btn btn-link px-0 d-flex w-100 justify-content-between align-items-center"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navProductsSub"
                  aria-expanded="false"
                  aria-controls="navProductsSub"
                >
                  Nos produits <i className="bi bi-chevron-down ms-1" />
                </button>

                <div id="navProductsSub" className="collapse">
                  <ul className="nav flex-column ps-2 py-1">
                    <li className="nav-item">
                      <Link className="nav-mobile-sublink" to="/medical/products"
                        onClick={() => { window.scrollTo(0, 0); document.getElementById('navMain')?.classList.remove('show'); }}>
                        Médical – Produits
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-mobile-sublink" to="/industrial/products"
                        onClick={() => { window.scrollTo(0, 0); document.getElementById('navMain')?.classList.remove('show'); }}>
                        Industriel – Produits
                      </Link>
                    </li>
                    <li className="nav-item"><hr className="my-1" /></li>
                    <li className="nav-item">
                      <Link className="nav-mobile-sublink" to="/medical/works"
                        onClick={() => { window.scrollTo(0, 0); document.getElementById('navMain')?.classList.remove('show'); }}>
                        Médical – Réalisations
                      </Link>
                    </li>
                    <li className="nav-item">
                      <Link className="nav-mobile-sublink" to="/industrial/works"
                        onClick={() => { window.scrollTo(0, 0); document.getElementById('navMain')?.classList.remove('show'); }}>
                        Industriel – Réalisations
                      </Link>
                    </li>
                  </ul>
                </div>
              </li>


              <li className="nav-item">
                <NavLink
                  to="/contact"
                  className="nav-link"
                  onClick={() => { scrollTop(); closeCollapseNow(); }}
                >
                  Contact
                </NavLink>
              </li>
            </ul>

            {/* CTA desktop */}
            <div className="d-none d-lg-flex align-items-center gap-2">
              <a
                className="btn btn-outline-success btn-sm"
                href="https://wa.me/22890119255"
                target="_blank"
                rel="noreferrer"
              >
                WhatsApp
              </a>
              <Link className="btn btn-success btn-sm" to="/contact" onClick={() => { scrollTop(); }}>
                Demander un devis
              </Link>
            </div>

            {/* CTA mobile */}
            <div className="d-grid gap-2 mt-3 d-lg-none">
              <a
                className="btn btn-outline-success"
                href="https://wa.me/22890119255"
                target="_blank"
                rel="noreferrer"
                onClick={closeCollapseNow}
              >
                WhatsApp
              </a>
              <Link
                className="btn btn-success"
                to="/contact"
                onClick={() => { scrollTop(); closeCollapseNow(); }}
              >
                Demander un devis
              </Link>
            </div>
          </div>
        </div>
      </nav>
    </>
  );
}
